import { makeAutoObservableSuper } from 'shared/lib/mobx/makeAutoObservableSuper'
import { type IResponseContactInfusionsoftIntegration } from 'entities/Contacts/api/types'
import { ContactIntegrationBase } from 'entities/Contacts/model/Integrations/ContactIntegrationBase'

export class ContactInfusionsoft extends ContactIntegrationBase<IResponseContactInfusionsoftIntegration> {
  integration_type: 'infusionsoft'

  constructor(response: IResponseContactInfusionsoftIntegration) {
    super(response)

    makeAutoObservableSuper(this)

    this.integration_type = 'infusionsoft'
    this.email = response.email
    this.national_number = response.phone
    this.phone = this.national_number
  }
}
